// extracted by mini-css-extract-plugin
export default {"Section":"get-account_Section__HGPF+","AccountDetails":"get-account_AccountDetails__DHNaf","NotLoggedIn":"get-account_NotLoggedIn__Yy+HK"};